import React from "react";
import { Button, Card, Header, List } from "semantic-ui-react";

import IParishPastName from "../../../data/parish/ParishPastName";
import "../../../static/priestProfile.css";
import CardRow from "../../priest-profile/CardRow";
import CardRowForDate from "../../priest-profile/CardRowForDate";

interface IPastNameCardProps {
    pastName: IParishPastName;
    index: number;
    editMode: boolean;
    handleDelete: (index: number) => void;
    handleChangeOnPastName: (labelName: string, value: any, index: number) => void;
}

const PastNameCard: React.FC<IPastNameCardProps> = (props: IPastNameCardProps) => {
    const { pastName, index, editMode, handleDelete, handleChangeOnPastName } = props;

    const handleDeletePressed = () => {
        handleDelete(index);
    };

    return (
        <Card fluid>
            <Card.Content>
                <Card.Content>
                    {editMode ? (
                        <Button color="red" floated="right" icon="trash" id="deleteButton" inverted onClick={handleDeletePressed} />
                    ) : (
                        <Card.Header id="header">
                            <Header as="h2">{pastName.name}</Header>
                        </Card.Header>
                    )}
                </Card.Content>

                <Card.Description>
                    <List>
                        {editMode && (
                            <List.Item>
                                <CardRow
                                    data={pastName.name}
                                    dataName="name"
                                    editMode={editMode}
                                    index={index}
                                    labelName="parishName"
                                    setValue={handleChangeOnPastName}
                                />
                            </List.Item>
                        )}
                        <List.Item>
                            <CardRowForDate
                                data={pastName.startDate}
                                dataName="startDate"
                                editMode={editMode}
                                index={index}
                                labelName="intervallStart"
                                setValue={handleChangeOnPastName}
                            />
                        </List.Item>
                        <List.Item>
                            <CardRowForDate
                                data={pastName.endDate}
                                dataName="endDate"
                                editMode={editMode}
                                index={index}
                                labelName="intervallEnd"
                                setValue={handleChangeOnPastName}
                            />
                        </List.Item>
                    </List>
                </Card.Description>
            </Card.Content>
        </Card>
    );
};

export default PastNameCard;
